export default [
  {
    path: '/reports',
    name: 'ReportsList',
    component: () => import('pages/reports/ReportsList.vue')
  },
  {
    path: '/reports/blueprints',
    name: 'ReportsBlueprintsList',
    component: () => import('pages/reports/ReportsBlueprintsList.vue')
  }
]
